<template>
  <div :class="{'prop-item': true, 'page-in-props': false}">
    <admin-form-item v-if="name"
                     class="prop-item-title"
                     :class="{}"><div class="lp-color-picker-title">{{ name }}</div></admin-form-item>

    <div class="brand-color-picker">
      <div class="brand-color-sel-group"
           style="display:flex ;align-items:center;">

        <!-- 컬러피커 색상 -->
        <div class="palette-color-sel-group">
          <div class="picker-pre-color"
               ref="preColor"
               @click="clickColor"
               :style="preColor()"></div>
          <!-- <div class="picker-color-rgb" @click="showPalettePicker=true;">aa</div> -->
          <div v-if="showPalettePicker"
               :style="pickerPosition"
               style="position:absolute;z-index:10;left:-34px;box-shadow: 1px 1px 5px #00000040;">
            <div class="color-picker-wrapper"
                 v-on-clickaway="closePalettePicker">
              <color-picker class="color-picker"
                            v-show="!showBrandPicker"
                            v-model="colors"
                            style="position:relative; box-shadow: unset;">
              </color-picker>
              <div v-if="showPalettePicker"
                   class="picker-brand-preset"
                   v-on-clickaway="closeBrandPicker"
                   style="width: 223px; z-index:10; background-color: #fff;">
                <!-- <span style="font-size: 14px;" @click="toggleBrandPicker">브랜드컬러에서 설정</span> -->
                <lp-color-drop-down @onSelect="selBrandColor"
                                    name="브랜드컬러에서 선택"
                                    :placeholder="'브랜드 컬러 선택'"
                                    :list="brandColorList"
                                    :brandName.sync="brandName"
                                    :opened="showBrandPicker"
                                    bgColor="#fff"
                                    fontSize="0.8rem"
                                    wrapHeight="28px"
                                    wrapPadding="0 4px"
                                    iconSize="1rem"
                                    listWidth="168px"
                                    style="''"
                                    :wrapStyle="{ border : '1px solid #ccc' }"
                                    @open="openBrandPicker"
                                    @close="closeBrandPicker"
                                    @closeAll="closeAllPicker">
                </lp-color-drop-down>
              </div>
            </div>
          </div>
        </div>
        <div class="color-string"
             :class="{ 'prop-selected': showPalettePicker }"
             @click="clickColor">
          <div>{{ colorString }}</div>
        </div>
      </div>

      <!-- 브랜드 컬러 -->
      <!--<div class="picker-pre-color-brand" :style="brandColor" v-else></div>-->
    </div>

  </div>
</template>

<script>
  import { directive as onClickaway } from 'vue-clickaway';
  import tinycolor from 'tinycolor2'
  import LpColorDropDown from './LpColorDropDown'
  //import LpColorDropDown from '@/components/components/common/LpColorDropDown'

  export default {
    directives: {
      onClickaway: onClickaway
    },
    components: {
      LpColorDropDown,
      // ChildColorPicker
    },
    props: {
      name: {
        type: String,
        default: ''
      },
      // lp.Color object
      val: {
        type: Object,
        required: true
      }
    },

    created() {
      this.colors.r = this.val.r;
      this.colors.g = this.val.g;
      this.colors.b = this.val.b;
      this.colors.a = this.val.a;
      if (this.val.brand !== undefined)
        this.brandName = this.val.brand;

      /*
      if(this.val !== undefined && this.val.r !== undefined) {
        this.colors = {
          hex: '#%s%s%s'.format(this.hex(this.val.r), this.hex(this.val.g), this.hex(this.val.b)),
          hsl: tinycolor(this.val).toHsl(),
          hsv: tinycolor(this.val).toHsv(),
          rgba: this.val,
          a: this.val.a
        }
      }
      */

      this.brands = this.$store.getters.brand.color_theme.data;
      if ( this.brands !== undefined ) {
        for(let i=0; i<this.brands.length ;i++) {
          if(this.group!==undefined && this.brands[i].types === 'group') {
            this.brandColorList.push({
              label: this.brands[i].name,
              value: this.brands[i].name
            });
          } else if(this.group===undefined && this.brands[i].types==='single') {
            this.brandColorList.push({
              label: this.brands[i].name,
              value: this.brands[i].name
            });
          }
        }
      }

      /*
      for (let i=0; i<Object.keys(this.brands).length; i++) {
        this.brandColorList.push({
          label: Object.keys(this.brands)[i],
          value: Object.keys(this.brands)[i]
        });
      }
      */
    },
    data() {
      return {
        pickerTop: false,               // 피커가 위/아래로 뜨는 위치 결정(true : 위 / false: 아래)
        showPalettePicker: false,
        showBrandPicker: false,
        colorType: [
          { label: '팔레트 컬러', value: true },
          { label: '브랜드 컬러', value: false }
        ],
        // 체크된 타입 (palette or brand)
        checkedType: 'palette',
        color: this.val,
        // 팔레트 RGBA 색상값
        colors : {
          rgba: {
            r: 0,
            g: 0,
            b: 0,
            a: 1
          }
        },
        // 브랜드 RGBA 색상값 (Pre Color용)
        brands: {},
        // 브랜드 컬러 넘기는 값
        brandColors: {},
        brandColorList: [],
        brandName: ''
      }
    },
    computed: {
      pickerPosition() {
        if(this.pickerTop)
          return 'bottom: 38px';
        else
          return 'top: 38px';
      },
      brandColor() {
        let style = {};
        if(this.brandColors.lpcolor !== undefined)
          style.backgroundColor = this.lpColorToString(find(this.brands, "name", this.brandColors.lpcolor).color);
        return style;
      },

      colorString() {
        if (this.val.brand !== undefined && this.val.brand !== '')
          return this.val.brand;

        return this.lpColorToString(this.val);
      }
    },
    watch: {
      colors(n) {
        let lpColor = {
          r: this.val.r,
          g: this.val.g,
          b: this.val.b,
          a: this.val.a,
          brand: ''
        };

        let rgba = n.rgba;
        lpColor.r = rgba.r;
        lpColor.g = rgba.g;
        lpColor.b = rgba.b;
        lpColor.a = rgba.a;
        this.color.r = lpColor.r;
        this.color.g = lpColor.g;
        this.color.b = lpColor.b;
        this.color.a = lpColor.a;
        this.color.brand = '';

        //this.$emit('update:val', this.color);
        // this.$emit('update:val', lpColor);
        // this.$emit('update:val', n.rgba);
        // this.targetColor = n;
      },
      brandColors(n) {
        // this.$emit('update:val', n);
      },
      val(n) {
        console.log('val changed', n);
        if ( n === undefined || n.r === undefined ) return ;

        this.color = this.val;
        /*
        this.colors = {
          hex: '#%s%s%s'.format(this.hex(n.r), this.hex(n.g), this.hex(n.b)),
          hsl: tinycolor(n).toHsl(),
          hsv: tinycolor(n).toHsv(),
          rgba: this.val,
          a: this.val.a
        }
        */
      },
      brandName(n) {
        let brandColor = this.getBrandColor(n);
        console.log(brandColor);

        let lpColor = {
          r: brandColor.color.r,
          g: brandColor.color.g,
          b: brandColor.color.b,
          a: brandColor.color.a,
          brand: n
        };
        this.$emit('update:val', lpColor);

        // Color picker를 위해 값 맞추기.
        // TODO: picker를 닫았다 열기 전까지 색상 적용이 안되는 문제 해결하기.
        this.colors.rgba = brandColor.color;
        this.colors.hex = this.lpColorToString(this.colors.rgba);
      }
    },
    methods: {
      clickColor(e) {
        //console.log(e.y, screen.);
        if(document.body.clientHeight < e.y + 300)
          this.pickerTop = true;
        else
          this.pickerTop = false;
        this.showPalettePicker=true;
      },
      hex(val) {
        let dt = '%x'.format(val);
        if(dt.length === 1)
          dt = '0' + dt;

        return dt;
      },
      preColor() {
        let rgba = undefined;
        if(this.val !== undefined && this.val.lpcolor !== undefined) {
          rgba = find(this.brands, "name", this.val.lpcolor);
          if(rgba === undefined)
            rgba = {r:0, g:0, b:0, a:1};
          else {
            rgba = rgba.color;
          }
        }
        else {
          rgba = this.val;
        }

        if(rgba === undefined)
          rgba = {r:0, g:0, b:0, a:1};

        // For brand color.
        if (this.val.brand !== undefined && this.val.brand !== '') {
          let brandColor = find(this.$store.getters.brand.colors, 'name',
            this.val.brand);
          rgba = brandColor.color;
        }

        if ( this.preSize === 'big' ) {
          let color = 'width:24px; height:24px; border:1px solid #000; background-color:rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a +')';
          return color;
        }
        else if ( this.preSize === undefined ) {

          let color = 'border:1px solid #ddd; background-color:rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a +')';
          return color;
        }
      },
      closePalettePicker() {
        this.showPalettePicker = false;
      },

      openBrandPicker() {
        this.showBrandPicker = true;
      },

      closeBrandPicker() {
        this.showBrandPicker = false;
      },

      closeAllPicker() {
        this.closePalettePicker();
        this.closeBrandPicker();
      },

      onInput(res) {
        this.colors.rgba = res.rgba;
        this.$emit('update:val', res.rgba);
      },
      changeCheckType(type) {
        // if ( type === '팔레트 컬러' ) {
        this.checkedType = type;
        this.$emit('update:val', this.colors.rgba);
        // }
        // else if ( type === '브랜드 컬러' ) {
        // this.checkedType = 'brand';
        // if ( this.brandColors.lpcolor !== undefined ) {
        // this.$emit('update:val', this.brandColors);
        // }
        // }
      },
      selBrandColor(type) {
        this.brandColors = {lpcolor: type };
        this.colors = find(this.brands, "name", this.brandColors.lpcolor).color;
        this.$emit('update:val', this.colors);
      },
      toggleBrandPicker() {
        this.showBrandPicker = (!this.showBrandPicker) ? true : false;
      },
      lpColorToString(color) {
        if(color.brand !== undefined && color.brand !== '') {
          let brand = this.getBrandColor(color.brand).color;
          color.r = brand.r;
          color.g = brand.g;
          color.b = brand.b;
          color.a = brand.a;
        }
        return this.colorToString(color);
      },

      colorToString(lpColor, brandHandler) {
        if (lpColor.brand !== '' && brandHandler !== undefined) {
          let brandColor = brandHandler(lpColor.brand);
          lpColor = (brandColor !== undefined) ? brandColor.color : lpColor;
        }
        if (lpColor.a === 1)
          return tinycolor(lpColor).toHexString().toUpperCase();
        return tinycolor(lpColor).toHex8String().toUpperCase();
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_variable'
  //@import '~assets/css/ui_main'
  .brand-color-picker
    border 1px solid #EEEEEE
    border-radius 3px
    width 200px
    height 32px

  .color-picker-wrapper
    position relative
    background-color white
  .picker-pre-color
    width 20px
    height 20px
    border-radius 3px

  .picker-pre-color-brand
    width 16px
    height 16px
    border 1px solid #000
    margin-left 4px

  .color-picker
    margin-left 3px
  .picker-close-btn
    width 15px
    height 15px
    // background-color red
    position absolute
    top 53px
    right 11px
  // text-align center
  .page-in-props
    margin-left 5px
  .page-in-props-title
    margin 10px 0 5px 0
    font-size 13px
    font-weight normal
    color #333

  .sel-color-picker-type
    border 1px solid #ff6e49
    display inline-block
    padding 4px 10px
    color #ff6e49
    font-size .9rem

  .selected-type
    background #ff6e49
    color #fff

  .palette-color-sel-group
    position relative
    margin-left 8px

  .color-string
    height 32px
    width 100%
    margin-left 4px
    padding 9px 10px
    display flex
    align-items center

  .lp-color-picker-title
    font-weight bold
    color #989898
    font-size 0.9rem
    margin-bottom 8px
</style>
